const REDUX_LOCAL_HAS_ASSOCIATION_CHANGE_KEY = 'localHasAssociationsChange'
export { REDUX_LOCAL_HAS_ASSOCIATION_CHANGE_KEY }
